import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";

const getBalance = () => {
    let url = apiUrlWithLang('/dashboard/api/balance')
    return axios.get(url)
}

const getTransactions = credentials => {
    let url = apiUrlWithLang('/dashboard/api/balance/transactions')
    return axios.get(url, { params:credentials })
}

export default {
    getBalance,
    getTransactions,
}
